var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirmation_number_black_24dp (2) 4",
    clipPath: "url(#clip0_4091_10224)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 71",
    x1: 1.47604,
    y1: 17.3668,
    x2: 14.976,
    y2: 0.866763,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 7.5V4.5C16.5 3.6675 15.825 3 15 3H3C2.175 3 1.5075 3.6675 1.5075 4.5V7.5C2.3325 7.5 3 8.175 3 9C3 9.825 2.3325 10.5 1.5 10.5V13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V10.5C15.675 10.5 15 9.825 15 9C15 8.175 15.675 7.5 16.5 7.5ZM15 6.405C14.1075 6.9225 13.5 7.8975 13.5 9C13.5 10.1025 14.1075 11.0775 15 11.595V13.5H3V11.595C3.8925 11.0775 4.5 10.1025 4.5 9C4.5 7.89 3.9 6.9225 3.0075 6.405L3 4.5H15V6.405ZM8.25 11.25H9.75V12.75H8.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 5.25H9.75V6.75H8.25V5.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_10224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelTicket);
export default __webpack_public_path__ + "static/media/cancel-ticket.82227dbfe765d1745e6b9a02a7ed0606.svg";
export { ForwardRef as ReactComponent };